// AUTO-GENERATED by scripts/inject-build-info.js — do not edit manually
export const BUILD_INFO = {
  commitHash: 'dev',
  buildTime: '2026-11-04T00:16:07.703Z',
} as const;
